module.exports = __webpack_public_path__ + "mobile/static/img/error.85ff6c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = aedp
// module chunks = 50